import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { useDialogStyledStyles } from 'styles';

const DialogStyled = ({
  open = false,
  title = '',
  handleClose,
  showCloseButton = false,
  children = '',
  fullWidth = true,
  maxWidth = 'sm',
  onAccept,
  acceptTitle = 'Aceptar',
  onCancel,
  cancelTitle = 'Cancelar',
  classNameBox = '',
  closeButtonColor = '#000',
  ...props
}) => {
  const classes = useDialogStyledStyles();

  return (
    <Dialog
      onClose={handleClose}
      fullWidth={fullWidth}
      maxWidth={maxWidth}
      open={open}
      classes={{
        paper: `${classes.mainBox} ${classNameBox}`,
      }}
      {...props}>
      {title || (handleClose && showCloseButton) ? (
        <DialogTitle className={classes.rootTitle}>
          {title}
          {handleClose && showCloseButton ? (
            <IconButton
              aria-label="close"
              id="closeModalButton"
              onClick={handleClose}
              sx={{
                position: 'absolute',
                right: 8,
                top: 8,
                color: closeButtonColor,
              }}>
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>
      ) : null}
      <DialogContent className={`${classes.content}`}>{children}</DialogContent>
      {(onCancel || onAccept) && (
        <DialogActions className={classes.rootActions}>
          {onCancel && (
            <Button variant="contained" size="small" onClick={onCancel}>
              {cancelTitle}
            </Button>
          )}
          {onAccept && (
            <Button
              autoFocus
              onClick={onAccept}
              size="small"
              color="primary"
              variant="primary">
              {acceptTitle}
            </Button>
          )}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default DialogStyled;
